// src/lib/getCursorCoords.ts
//
// textarea 内のカーソル位置をピクセル座標で返す。
// position:relative なラッパー内で absolute 配置するための座標を計算する。
// （ミラーdiv 技法：同じスタイルの div をレンダリングしてカーソル位置を測定）

export function getCursorCoords(
  textarea: HTMLTextAreaElement
): { top: number; left: number } {
  const pos = textarea.selectionStart ?? textarea.value.length;
  const computed = window.getComputedStyle(textarea);
  const elRect = textarea.getBoundingClientRect();

  // ミラー div を body に追加（textarea と同じ位置・スタイル）
  const mirror = document.createElement("div");
  document.body.appendChild(mirror);

  // textarea と同じレイアウトになるよう CSS をコピー
  mirror.style.cssText = `
    position: fixed;
    top: ${elRect.top}px;
    left: ${elRect.left}px;
    width: ${elRect.width}px;
    box-sizing: ${computed.boxSizing};
    padding-top: ${computed.paddingTop};
    padding-right: ${computed.paddingRight};
    padding-bottom: ${computed.paddingBottom};
    padding-left: ${computed.paddingLeft};
    border-top-width: ${computed.borderTopWidth};
    border-right-width: ${computed.borderRightWidth};
    border-bottom-width: ${computed.borderBottomWidth};
    border-left-width: ${computed.borderLeftWidth};
    border-style: solid;
    border-color: transparent;
    font-family: ${computed.fontFamily};
    font-size: ${computed.fontSize};
    font-weight: ${computed.fontWeight};
    font-style: ${computed.fontStyle};
    line-height: ${computed.lineHeight};
    letter-spacing: ${computed.letterSpacing};
    word-spacing: ${computed.wordSpacing};
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
    visibility: hidden;
    pointer-events: none;
    z-index: -1;
  `;

  // カーソル位置までのテキスト + マーカースパン
  mirror.textContent = textarea.value.substring(0, pos);
  const span = document.createElement("span");
  span.textContent = "​"; // ゼロ幅スペース（マーカー）
  mirror.appendChild(span);

  const spanRect = span.getBoundingClientRect();
  document.body.removeChild(mirror);

  const lineHeight = parseFloat(computed.lineHeight) || 20;

  // textarea のスクロールを考慮した座標（ラッパー div 起点の絶対位置）
  const top = spanRect.top - elRect.top - textarea.scrollTop + lineHeight + 2;
  const left = Math.max(0, Math.min(spanRect.left - elRect.left, elRect.width - 160));

  return { top, left };
}
